import React from "react";

export const AiSparkleIcon = ({
  width = 20,
  height = 20,
  fill = "#148EFF",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4372 10.0828L11.4075 8.59375L9.9231 4.56094C9.83519 4.32213 9.67616 4.11604 9.46744 3.97046C9.25873 3.82488 9.01038 3.74682 8.75591 3.74682C8.50144 3.74682 8.25309 3.82488 8.04438 3.97046C7.83566 4.11604 7.67663 4.32213 7.58872 4.56094L6.09497 8.59375L2.06216 10.0781C1.82336 10.166 1.61726 10.3251 1.47168 10.5338C1.3261 10.7425 1.24805 10.9908 1.24805 11.2453C1.24805 11.4998 1.3261 11.7481 1.47168 11.9568C1.61726 12.1656 1.82336 12.3246 2.06216 12.4125L6.09497 13.9062L7.57935 17.9391C7.66725 18.1779 7.82629 18.384 8.035 18.5295C8.24372 18.6751 8.49207 18.7532 8.74654 18.7532C9.00101 18.7532 9.24935 18.6751 9.45807 18.5295C9.66678 18.384 9.82582 18.1779 9.91372 17.9391L11.4075 13.9062L15.4403 12.4219C15.6791 12.334 15.8852 12.1749 16.0308 11.9662C16.1763 11.7575 16.2544 11.5092 16.2544 11.2547C16.2544 11.0002 16.1763 10.7519 16.0308 10.5432C15.8852 10.3344 15.6791 10.1754 15.4403 10.0875L15.4372 10.0828ZM10.7043 12.8297C10.6195 12.861 10.5425 12.9103 10.4785 12.9742C10.4146 13.0381 10.3653 13.1152 10.334 13.2L8.75122 17.4883L7.17154 13.2031C7.14032 13.1174 7.09071 13.0395 7.0262 12.975C6.96168 12.9105 6.88383 12.8609 6.7981 12.8297L2.51294 11.25L6.7981 9.67031C6.88383 9.6391 6.96168 9.58949 7.0262 9.52497C7.09071 9.46046 7.14032 9.3826 7.17154 9.29688L8.75122 5.01172L10.3309 9.29688C10.3622 9.38171 10.4115 9.45875 10.4754 9.52269C10.5393 9.58662 10.6164 9.63592 10.7012 9.66719L14.9895 11.25L10.7043 12.8297ZM11.2512 3.125C11.2512 2.95924 11.3171 2.80027 11.4343 2.68306C11.5515 2.56585 11.7105 2.5 11.8762 2.5H13.1262V1.25C13.1262 1.08424 13.1921 0.925268 13.3093 0.808058C13.4265 0.690848 13.5855 0.625 13.7512 0.625C13.917 0.625 14.076 0.690848 14.1932 0.808058C14.3104 0.925268 14.3762 1.08424 14.3762 1.25V2.5H15.6262C15.792 2.5 15.951 2.56585 16.0682 2.68306C16.1854 2.80027 16.2512 2.95924 16.2512 3.125C16.2512 3.29076 16.1854 3.44973 16.0682 3.56694C15.951 3.68415 15.792 3.75 15.6262 3.75H14.3762V5C14.3762 5.16576 14.3104 5.32473 14.1932 5.44194C14.076 5.55915 13.917 5.625 13.7512 5.625C13.5855 5.625 13.4265 5.55915 13.3093 5.44194C13.1921 5.32473 13.1262 5.16576 13.1262 5V3.75H11.8762C11.7105 3.75 11.5515 3.68415 11.4343 3.56694C11.3171 3.44973 11.2512 3.29076 11.2512 3.125ZM19.3762 6.875C19.3762 7.04076 19.3104 7.19973 19.1932 7.31694C19.076 7.43415 18.917 7.5 18.7512 7.5H18.1262V8.125C18.1262 8.29076 18.0604 8.44973 17.9432 8.56694C17.826 8.68415 17.667 8.75 17.5012 8.75C17.3355 8.75 17.1765 8.68415 17.0593 8.56694C16.9421 8.44973 16.8762 8.29076 16.8762 8.125V7.5H16.2512C16.0855 7.5 15.9265 7.43415 15.8093 7.31694C15.6921 7.19973 15.6262 7.04076 15.6262 6.875C15.6262 6.70924 15.6921 6.55027 15.8093 6.43306C15.9265 6.31585 16.0855 6.25 16.2512 6.25H16.8762V5.625C16.8762 5.45924 16.9421 5.30027 17.0593 5.18306C17.1765 5.06585 17.3355 5 17.5012 5C17.667 5 17.826 5.06585 17.9432 5.18306C18.0604 5.30027 18.1262 5.45924 18.1262 5.625V6.25H18.7512C18.917 6.25 19.076 6.31585 19.1932 6.43306C19.3104 6.55027 19.3762 6.70924 19.3762 6.875Z"
      fill={fill}
    />
  </svg>
);

export const DUMMY_TABLE_DATA = [
  {
    id: "721b0e9a-7b3c-4e8f-9d0b-2f7a0c1a9c8d",
    title: "Senior PHP Developer",
    field: "Software Development",
    department: "IT",
    createdDate: "12-01-2021",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "8c4f2d0e-5a6b-4c91-b3d5-1e8b7f2d0a4c",
    title: "Full Stack JavaScript Engineer",
    field: "Web Development",
    department: "IT",
    createdDate: "05-03-2021",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "a1b3c5d7-e9f0-4a2b-8c4d-6e0f1a2b3c4d",
    title: "Financial Analyst II",
    field: "Corporate Finance",
    department: "Finance",
    createdDate: "20-05-2021",
    recruiter: "Amit Patel",
    status: 2, // Completed
  },
  {
    id: "b2d4f6a8-0c1e-4d3f-9e7c-5b6a7d8e9f0c",
    title: "HR Business Partner",
    field: "Talent Acquisition",
    department: "Human Resources",
    createdDate: "01-08-2021",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "d3e5f7a9-1d2f-4b0c-8a9d-7c8b9a0d1e2f",
    title: "Marketing Manager - Digital",
    field: "Digital Marketing",
    department: "Marketing",
    createdDate: "15-09-2021",
    recruiter: "Vikram Saini",
    status: -1, // Not Started
  },
  {
    id: "e4f6a8b0-2e3d-4c1a-9f0b-8d7c6b5a4d3e",
    title: "Data Scientist - Lead",
    field: "Machine Learning",
    department: "Data & Analytics",
    createdDate: "28-11-2021",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "f5a7b9c1-3f4e-4d2b-8c1a-9e0f1d2c3b4a",
    title: "Sales Executive (B2B)",
    field: "Enterprise Sales",
    department: "Sales",
    createdDate: "03-01-2022",
    recruiter: "Rahul Sharma",
    status: 0, // Paused
  },
  {
    id: "0a1b2c3d-4e5f-4678-9012-34567890abcd",
    title: "UX/UI Designer",
    field: "Product Design",
    department: "Product",
    createdDate: "10-02-2022",
    recruiter: "Amit Patel",
    status: 2, // Completed
  },
  {
    id: "1b2c3d4e-5f6a-4789-0123-4567890abcde",
    title: "Cloud Infrastructure Architect",
    field: "DevOps",
    department: "IT",
    createdDate: "18-03-2022",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "2c3d4e5f-6a7b-4890-1234-567890abcdef",
    title: "Content Writer - Technical",
    field: "Technical Documentation",
    department: "Marketing",
    createdDate: "22-04-2022",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "3d4e5f6a-7b8c-4901-2345-67890abcdef0",
    title: "Junior Accountant",
    field: "General Accounting",
    department: "Finance",
    createdDate: "05-06-2022",
    recruiter: "Rahul Sharma",
    status: -1, // Not Started
  },
  {
    id: "4e5f6a7b-8c9d-4a12-3456-7890abcdef01",
    title: "Customer Support Specialist",
    field: "Customer Relations",
    department: "Operations",
    createdDate: "19-07-2022",
    recruiter: "Priya Singh",
    status: 2, // Completed
  },
  {
    id: "5f6a7b8c-9d0e-4b23-4567-890abcdef012",
    title: "Mobile App Developer (iOS)",
    field: "Mobile Development",
    department: "IT",
    createdDate: "01-09-2022",
    recruiter: "Amit Patel",
    status: 1, // On Going
  },
  {
    id: "6a7b8c9d-0e1f-4c34-5678-90abcdef0123",
    title: "Project Manager - Construction",
    field: "Civil Engineering",
    department: "Engineering",
    createdDate: "10-10-2022",
    recruiter: "Deepa Menon",
    status: 0, // Paused
  },
  {
    id: "7b8c9d0e-1f2a-4d45-6789-0abcdef01234",
    title: "Supply Chain Analyst",
    field: "Logistics",
    department: "Operations",
    createdDate: "25-11-2022",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "8c9d0e1f-2a3b-4e56-7890-abcdef012345",
    title: "Executive Assistant to CEO",
    field: "Administrative Support",
    department: "Administration",
    createdDate: "14-12-2022",
    recruiter: "Rahul Sharma",
    status: 2, // Completed
  },
  {
    id: "9d0e1f2a-3b4c-4f67-890a-bcdef0123456",
    title: "Network Security Engineer",
    field: "Cybersecurity",
    department: "IT",
    createdDate: "02-01-2023",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "a0b1c2d3-4e5f-4178-90bc-def012345678",
    title: "Quality Assurance Tester",
    field: "Software Testing",
    department: "IT",
    createdDate: "17-02-2023",
    recruiter: "Amit Patel",
    status: -1, // Not Started
  },
  {
    id: "b1c2d3e4-5f6a-4289-01cd-ef0123456789",
    title: "Recruitment Coordinator",
    field: "HR Operations",
    department: "Human Resources",
    createdDate: "04-03-2023",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "c2d3e4f5-6a7b-4390-12de-f01234567890",
    title: "Product Manager - Senior",
    field: "Product Strategy",
    department: "Product",
    createdDate: "11-04-2023",
    recruiter: "Vikram Saini",
    status: 2, // Completed
  },
  {
    id: "d3e4f5a6-7b8c-4401-23ef-012345678901",
    title: "Biomedical Engineer",
    field: "Medical Devices",
    department: "R&D",
    createdDate: "29-05-2023",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "e4f5a6b7-8c9d-4512-34f0-123456789012",
    title: "Front-End Developer (React)",
    field: "Web Development",
    department: "IT",
    createdDate: "07-06-2023",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "f5a6b7c8-9d0e-4623-4501-234567890123",
    title: "Account Executive",
    field: "Client Management",
    department: "Sales",
    createdDate: "14-07-2023",
    recruiter: "Amit Patel",
    status: 0, // Paused
  },
  {
    id: "0a6b7c8d-9e0f-4734-5612-345678901234",
    title: "HRIS Specialist",
    field: "Information Systems",
    department: "Human Resources",
    createdDate: "21-08-2023",
    recruiter: "Deepa Menon",
    status: 2, // Completed
  },
  {
    id: "1b7c8d9e-0f1a-4845-6723-456789012345",
    title: "SEO Specialist",
    field: "Search Engine Optimization",
    department: "Marketing",
    createdDate: "09-09-2023",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "2c8d9e0f-1a2b-4956-7834-567890123456",
    title: "Senior PHP Developer",
    field: "Software Development",
    department: "IT",
    createdDate: "18-09-2023",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "3d9e0f1a-2b3c-4a67-8945-678901234567",
    title: "IT Support Technician",
    field: "Desktop Support",
    department: "IT",
    createdDate: "01-10-2023",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "4e0f1a2b-3c4d-4b78-9056-789012345678",
    title: "Management Trainee",
    field: "Business Administration",
    department: "Operations",
    createdDate: "15-10-2023",
    recruiter: "Amit Patel",
    status: -1, // Not Started
  },
  {
    id: "5f1a2b3c-4d5e-4c89-0167-890123456789",
    title: "Copywriter - Senior",
    field: "Advertising",
    department: "Marketing",
    createdDate: "04-11-2023",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "6a2b3c4d-5e6f-4d90-1278-901234567890",
    title: "Financial Planning Analyst",
    field: "FP&A",
    department: "Finance",
    createdDate: "20-11-2023",
    recruiter: "Vikram Saini",
    status: 2, // Completed
  },
  {
    id: "7b3c4d5e-6f7a-4e01-2389-012345678901",
    title: "Civil Engineer",
    field: "Infrastructure",
    department: "Engineering",
    createdDate: "01-12-2023",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "8c4d5e6f-7a8b-4f12-3490-123456789012",
    title: "Java Backend Developer",
    field: "Enterprise Software",
    department: "IT",
    createdDate: "10-12-2023",
    recruiter: "Priya Singh",
    status: 0, // Paused
  },
  {
    id: "9d5e6f7a-8b9c-4023-45a1-234567890123",
    title: "Paralegal",
    field: "Corporate Law",
    department: "Legal",
    createdDate: "15-12-2023",
    recruiter: "Amit Patel",
    status: 1, // On Going
  },
  {
    id: "a0e6f7a8-b9c0-4134-56b2-345678901234",
    title: "Training & Development Specialist",
    field: "Organizational Learning",
    department: "Human Resources",
    createdDate: "03-01-2024",
    recruiter: "Deepa Menon",
    status: -1, // Not Started
  },
  {
    id: "b1f7a8b9-c0d1-4245-67c3-456789012345",
    title: "E-commerce Specialist",
    field: "Online Retail",
    department: "Sales",
    createdDate: "20-01-2024",
    recruiter: "Vikram Saini",
    status: 2, // Completed
  },
  {
    id: "c2a8b9c0-d1e2-4356-78d4-567890123456",
    title: "Scrum Master",
    field: "Agile Project Management",
    department: "IT",
    createdDate: "05-02-2024",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "d3b9c0d1-e2f3-4467-89e5-678901234567",
    title: "System Administrator",
    field: "Network Operations",
    department: "IT",
    createdDate: "12-02-2024",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "e4c0d1e2-f3a4-4578-90f6-789012345678",
    title: "Audit Associate",
    field: "External Audit",
    department: "Finance",
    createdDate: "18-02-2024",
    recruiter: "Amit Patel",
    status: 1, // On Going
  },
  {
    id: "f5d1e2f3-a4b5-4689-0107-890123456789",
    title: "Manufacturing Engineer",
    field: "Production Optimization",
    department: "Engineering",
    createdDate: "25-02-2024",
    recruiter: "Deepa Menon",
    status: 0, // Paused
  },
  {
    id: "0e2f3a4b-5c6d-4790-1218-901234567890",
    title: "Digital Marketing Analyst",
    field: "Performance Marketing",
    department: "Marketing",
    createdDate: "01-03-2024",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "1f3a4b5c-6d7e-4801-2329-012345678901",
    title: "Operations Manager",
    field: "Process Improvement",
    department: "Operations",
    createdDate: "08-03-2024",
    recruiter: "Rahul Sharma",
    status: 2, // Completed
  },
  {
    id: "2a4b5c6d-7e8f-4912-3430-123456789012",
    title: "Technical Writer",
    field: "Documentation",
    department: "IT",
    createdDate: "15-03-2024",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "3b5c6d7e-8f9a-4a23-4541-234567890123",
    title: "Graphic Designer",
    field: "Visual Communication",
    department: "Marketing",
    createdDate: "22-03-2024",
    recruiter: "Amit Patel",
    status: -1, // Not Started
  },
  {
    id: "4c6d7e8f-9a0b-4b34-5652-345678901234",
    title: "Compliance Officer",
    field: "Regulatory Affairs",
    department: "Legal",
    createdDate: "29-03-2024",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "5d7e8f9a-0b1c-4c45-6763-456789012345",
    title: "DevOps Engineer",
    field: "Automation",
    department: "IT",
    createdDate: "05-04-2024",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "6e8f9a0b-1c2d-4d56-7874-567890123456",
    title: "Sales Development Rep",
    field: "Lead Generation",
    department: "Sales",
    createdDate: "12-04-2024",
    recruiter: "Rahul Sharma",
    status: 0, // Paused
  },
  {
    id: "7f9a0b1c-2d3e-4e67-8985-678901234567",
    title: "Research Scientist",
    field: "Chemical Engineering",
    department: "R&D",
    createdDate: "19-04-2024",
    recruiter: "Priya Singh",
    status: 1, // On Going
  },
  {
    id: "8a0b1c2d-3e4f-4f78-9096-789012345678",
    title: "Product Analyst",
    field: "Market Research",
    department: "Product",
    createdDate: "26-04-2024",
    recruiter: "Amit Patel",
    status: 2, // Completed
  },
  {
    id: "9b1c2d3e-4f5a-4089-01a7-890123456789",
    title: "Recruiter - Tech",
    field: "Sourcing",
    department: "Human Resources",
    createdDate: "03-05-2024",
    recruiter: "Deepa Menon",
    status: 1, // On Going
  },
  {
    id: "a0c2d3e4-5f6b-4190-12b8-901234567890",
    title: "Financial Accountant",
    field: "Reporting",
    department: "Finance",
    createdDate: "10-05-2024",
    recruiter: "Vikram Saini",
    status: 1, // On Going
  },
  {
    id: "b1d3e4f5-6a7c-4201-23c9-012345678901",
    title: "Senior PHP Developer (Re-run)",
    field: "Software Development",
    department: "IT",
    createdDate: "15-05-2024",
    recruiter: "Rahul Sharma",
    status: 1, // On Going
  },
  {
    id: "c2e4f5a6-7b8d-4312-34d0-123456789012",
    title: "Marketing Coordinator",
    field: "Campaign Management",
    department: "Marketing",
    createdDate: "20-05-2024",
    recruiter: "Priya Singh",
    status: -1, // Not Started
  },
  {
    id: "d3f5a6b7-8c9e-4423-45e1-234567890123",
    title: "Data Engineer",
    field: "ETL Processes",
    department: "Data & Analytics",
    createdDate: "25-05-2024",
    recruiter: "Amit Patel",
    status: 0, // Paused
  },
];

export const REVERSE_STATUS_MAPPER = {
  COMPLETED: 3,
  ONGOING: 2,
  PAUSED: 1,
  NOT_STARTED: 0,
};

export const STATUS_TO_TYPE_MAPPER = {
  3: {
    type: "Completed",
    variant: "success",
  },
  2: {
    type: "Ongoing",
    variant: "success",
  },
  1: {
    type: "Paused",
    variant: "default",
  },
  0: {
    type: "Not Started",
    variant: "default",
  },
};

export const DUMMY_CARD_DATA = [
  {
    title: "Total Outreach",
    count: 120,
  },
  {
    title: "Applied",
    count: 24,
    percentage: 20,
  },
  {
    title: "Interviewed",
    count: 24,
    percentage: 20,
  },
  {
    title: "Shortlisted",
    count: 12,
    percentage: 10,
  },
];

export const DUMMY_CANDIDATE_DATA = [
  {
    id: "a1b3c5d7-e9f0-4a2b-8c4d-6e0f1a2b3c4d",
    name: "Rahul Sharma",
    skills: "HTML, CSS, JavaScript, React",
    YOE: 4,
    highestEducation: "Bachelors in CS",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/rahul-sharma-7b3c",
  },
  {
    id: "b2d4f6a8-0c1e-4d3f-9e7c-5b6a7d8e9f0c",
    name: "Priya Singh",
    skills: "Python, Machine Learning, TensorFlow",
    YOE: 7,
    highestEducation: "Masters in AI",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/priya-singh-5a6b",
  },
  {
    id: "d3e5f7a9-1d2f-4b0c-8a9d-7c8b9a0d1e2f",
    name: "Amit Patel",
    skills: "Corporate Finance, Valuation, Excel",
    YOE: 5,
    highestEducation: "MBA",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/amit-patel-e2f3",
  },
  {
    id: "e4f6a8b0-2e3d-4c1a-9f0b-8d7c6b5a4d3e",
    name: "Deepa Menon",
    skills: "Talent Acquisition, HRIS, Employee Relations",
    YOE: 8,
    highestEducation: "Masters in HR",
    source: "CareerBuilder",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/deepa-menon-4c91",
  },
  {
    id: "f5a7b9c1-3f4e-4d2b-8c1a-9e0f1d2c3b4a",
    name: "Vikram Saini",
    skills: "SEO, SEM, Google Analytics, Content Strategy",
    YOE: 6,
    highestEducation: "Bachelors in Marketing",
    source: "Indeed",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/vikram-saini-3b4c",
  },
  {
    id: "0a1b2c3d-4e5f-4678-9012-34567890abcd",
    name: "Rohan Kapoor",
    skills: "Java, Spring Boot, Microservices, AWS",
    YOE: 10,
    highestEducation: "Bachelors in Engineering",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/rohan-kapoor-7890",
  },
  {
    id: "1b2c3d4e-5f6a-4789-0123-4567890abcde",
    name: "Anjali Verma",
    skills: "UX Research, Figma, Prototyping",
    YOE: 3,
    highestEducation: "Masters in Design",
    source: "Dribbble",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/anjali-verma-0123",
  },
  {
    id: "2c3d4e5f-6a7b-4890-1234-567890abcdef",
    name: "Sanjay Reddy",
    skills: "SQL, Tableau, Data Warehousing",
    YOE: 9,
    highestEducation: "Masters in Data Science",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/sanjay-reddy-1234",
  },
  {
    id: "3d4e5f6a-7b8c-4901-2345-67890abcdef0",
    name: "Neha Gupta",
    skills: "Technical Writing, API Documentation",
    YOE: 5,
    highestEducation: "Bachelors in Communications",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/neha-gupta-2345",
  },
  {
    id: "4e5f6a7b-8c9d-4a12-3456-7890abcdef01",
    name: "Alok Jain",
    skills: "Sales Strategy, CRM, Negotiation",
    YOE: 12,
    highestEducation: "MBA",
    source: "Internal Transfer",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/alok-jain-3456",
  },
  {
    id: "5f6a7b8c-9d0e-4b23-4567-890abcdef012",
    name: "Kavita Rao",
    skills: "General Accounting, GAAP, Tally",
    YOE: 2,
    highestEducation: "Bachelors in Commerce",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/kavita-rao-4567",
  },
  {
    id: "6a7b8c9d-0e1f-4c34-5678-90abcdef0123",
    name: "Gaurav Das",
    skills: "Customer Support, Zendesk, Troubleshooting",
    YOE: 1,
    highestEducation: "High School",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/gaurav-das-5678",
  },
  {
    id: "7b8c9d0e-1f2a-4d45-6789-0abcdef01234",
    name: "Shekhar Nair",
    skills: "Swift, Kotlin, Mobile UI/UX",
    YOE: 6,
    highestEducation: "Bachelors in IT",
    source: "Monster",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/shekhar-nair-6789",
  },
  {
    id: "8c9d0e1f-2a3b-4e56-7890-abcdef012345",
    name: "Mona Shah",
    skills: "Civil Engineering, AutoCAD, Project Management",
    YOE: 15,
    highestEducation: "Masters in Civil Eng.",
    source: "Referral",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/mona-shah-7890",
  },
  {
    id: "9d0e1f2a-3b4c-4f67-890a-bcdef0123456",
    name: "Tarun Bajaj",
    skills: "Supply Chain Management, SAP, Logistics",
    YOE: 7,
    highestEducation: "MBA in Operations",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/tarun-bajaj-890a",
  },
  {
    id: "a0b1c2d3-4e5f-4178-90bc-def012345678",
    name: "Nidhi Kumar",
    skills: "Administrative Support, Scheduling, MS Office",
    YOE: 4,
    highestEducation: "Bachelors",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/nidhi-kumar-90bc",
  },
  {
    id: "b1c2d3e4-5f6a-4289-01cd-ef0123456789",
    name: "Abhishek Kulkarni",
    skills: "Cybersecurity, Penetration Testing, CISSP",
    YOE: 11,
    highestEducation: "Masters in Cybersecurity",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/abhishek-kulkarni-01cd",
  },
  {
    id: "c2d3e4f5-6a7b-4390-12de-f01234567890",
    name: "Sonam Bansal",
    skills: "Software Testing, Selenium, Jira",
    YOE: 3,
    highestEducation: "Bachelors in CS",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/sonam-bansal-12de",
  },
  {
    id: "d3e4f5a6-7b8c-4401-23ef-012345678901",
    name: "Vivek Taneja",
    skills: "Recruitment, Applicant Tracking Systems (ATS)",
    YOE: 5,
    highestEducation: "Bachelors in Psychology",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/vivek-taneja-23ef",
  },
  {
    id: "e4f5a6b7-8c9d-4512-34f0-123456789012",
    name: "Preeti Iyer",
    skills: "Product Strategy, Roadmap Development, Agile",
    YOE: 10,
    highestEducation: "MBA in Strategy",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/preeti-iyer-34f0",
  },
  {
    id: "f5a6b7c8-9d0e-4623-4501-234567890123",
    name: "Bhavya Joshi",
    skills: "Biomedical Engineering, MATLAB, FDA Regulations",
    YOE: 8,
    highestEducation: "PhD in Biomedical Eng.",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/bhavya-joshi-4501",
  },
  {
    id: "0a6b7c8d-9e0f-4734-5612-345678901234",
    name: "Deepak Choudhary",
    skills: "React, Redux, Node.js",
    YOE: 4,
    highestEducation: "Bachelors in IT",
    source: "Monster",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/deepak-choudhary-5612",
  },
  {
    id: "1b7c8d9e-0f1a-4845-6723-456789012345",
    name: "Shalini Mehra",
    skills: "Client Management, Upselling, Salesforce",
    YOE: 7,
    highestEducation: "Bachelors in Business",
    source: "Indeed",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/shalini-mehra-6723",
  },
  {
    id: "2c8d9e0f-1a2b-4956-7834-567890123456",
    name: "Himanshu Aggarwal",
    skills: "HRIS, SAP HCM, Data Migration",
    YOE: 9,
    highestEducation: "Masters in Technology",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/himanshu-aggarwal-7834",
  },
  {
    id: "3d9e0f1a-2b3c-4a67-8945-678901234567",
    name: "Juhi Bansal",
    skills: "Search Engine Optimization, Ahrefs, SEMRush",
    YOE: 6,
    highestEducation: "Bachelors in Mass Comm.",
    source: "Northstarz",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/juhi-bansal-8945",
  },
  {
    id: "4e0f1a2b-3c4d-4b78-9056-789012345678",
    name: "Rajat Khanna",
    skills: "PHP, Laravel, MySQL",
    YOE: 4,
    highestEducation: "Bachelors in CS",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/rajat-khanna-9056",
  },
  {
    id: "5f1a2b3c-4d5e-4c89-0167-890123456789",
    name: "Ishita Rao",
    skills: "Desktop Support, Active Directory, Windows OS",
    YOE: 2,
    highestEducation: "Associate Degree",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/ishita-rao-0167",
  },
  {
    id: "6a2b3c4d-5e6f-4d90-1278-901234567890",
    name: "Siddharth Jain",
    skills: "Business Administration, Leadership, Strategy",
    YOE: 0,
    highestEducation: "Bachelors in Management",
    source: "University Placement",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/siddharth-jain-1278",
  },
  {
    id: "7b3c4d5e-6f7a-4e01-2389-012345678901",
    name: "Pooja Hegde",
    skills: "Advertising Copy, Creative Strategy, Branding",
    YOE: 10,
    highestEducation: "Masters in Fine Arts",
    source: "Referral",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/pooja-hegde-2389",
  },
  {
    id: "8c4d5e6f-7a8b-4f12-3490-123456789012",
    name: "Arvind Mishra",
    skills: "Financial Modeling, Budgeting, Forecasting",
    YOE: 5,
    highestEducation: "CFA, MBA",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/arvind-mishra-3490",
  },
  {
    id: "9d5e6f7a-8b9c-4023-45a1-234567890123",
    name: "Kiran Bedi",
    skills: "Infrastructure Planning, Geotechnical Analysis",
    YOE: 15,
    highestEducation: "Masters in Civil Eng.",
    source: "Monster",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/kiran-bedi-45a1",
  },
  {
    id: "a0e6f7a8-b9c0-4134-56b2-345678901234",
    name: "Vishal Dev",
    skills: "Java, REST APIs, PostgreSQL",
    YOE: 8,
    highestEducation: "Bachelors in Engineering",
    source: "Indeed",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/vishal-dev-56b2",
  },
  {
    id: "b1f7a8b9-c0d1-4245-67c3-456789012345",
    name: "Naina Saxena",
    skills: "Corporate Law, Contract Drafting, Compliance",
    YOE: 3,
    highestEducation: "Juris Doctor (JD)",
    source: "Northstarz",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/naina-saxena-67c3",
  },
  {
    id: "c2a8b9c0-d1e2-4356-78d4-567890123456",
    name: "Sunita Das",
    skills: "Training Needs Assessment, E-Learning Dev.",
    YOE: 6,
    highestEducation: "Bachelors in Education",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/sunita-das-78d4",
  },
  {
    id: "d3b9c0d1-e2f3-4467-89e5-678901234567",
    name: "Ashish Sharma",
    skills: "E-commerce Platforms (Shopify), Digital Sales",
    YOE: 4,
    highestEducation: "Bachelors in Commerce",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/ashish-sharma-89e5",
  },
  {
    id: "e4c0d1e2-f3a4-4578-90f6-789012345678",
    name: "Shruti Sinha",
    skills: "Scrum, Kanban, JIRA, Confluence",
    YOE: 7,
    highestEducation: "PMP Certified",
    source: "Monster",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/shruti-sinha-90f6",
  },
  {
    id: "f5d1e2f3-a4b5-4689-0107-890123456789",
    name: "Rajesh Menon",
    skills: "Network Administration, Cisco, Linux",
    YOE: 10,
    highestEducation: "Masters in IT",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/rajesh-menon-0107",
  },
  {
    id: "0e2f3a4b-5c6d-4790-1218-901234567890",
    name: "Meera Hegde",
    skills: "External Audit, IFRS, Risk Assessment",
    YOE: 5,
    highestEducation: "CA/CPA",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/meera-hegde-1218",
  },
  {
    id: "1f3a4b5c-6d7e-4801-2329-012345678901",
    name: "Jatin Khanna",
    skills: "Production Optimization, Lean Manufacturing",
    YOE: 12,
    highestEducation: "Bachelors in Mech. Eng.",
    source: "Northstarz",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/jatin-khanna-2329",
  },
  {
    id: "2a4b5c6d-7e8f-4912-3430-123456789012",
    name: "Lata Verma",
    skills: "Performance Marketing, Social Media Ads",
    YOE: 3,
    highestEducation: "Bachelors in Mass Comm.",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/lata-verma-3430",
  },
  {
    id: "3b5c6d7e-8f9a-4a23-4541-234567890123",
    name: "Prashant Dev",
    skills: "Process Improvement, Six Sigma, Operations",
    YOE: 15,
    highestEducation: "MBA in Operations",
    source: "Monster",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/prashant-dev-4541",
  },
  {
    id: "4c6d7e8f-9a0b-4b34-5652-345678901234",
    name: "Shreya Bhatia",
    skills: "Technical Documentation, MadCap Flare",
    YOE: 6,
    highestEducation: "Bachelors in English",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/shreya-bhatia-5652",
  },
  {
    id: "5d7e8f9a-0b1c-4c45-6763-456789012345",
    name: "Mohit Jain",
    skills: "Adobe Creative Suite, Branding, Illustration",
    YOE: 2,
    highestEducation: "Associate Degree in Design",
    source: "Dribbble",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/mohit-jain-6763",
  },
  {
    id: "6e8f9a0b-1c2d-4d56-7874-567890123456",
    name: "Ritika Sharma",
    skills: "Regulatory Affairs, ISO Standards",
    YOE: 8,
    highestEducation: "Masters in Law",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/ritika-sharma-7874",
  },
  {
    id: "7f9a0b1c-2d3e-4e67-8985-678901234567",
    name: "Aditya Singh",
    skills: "CI/CD, Kubernetes, Terraform",
    YOE: 5,
    highestEducation: "Bachelors in Engineering",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/aditya-singh-8985",
  },
  {
    id: "8a0b1c2d-3e4f-4f78-9096-789012345678",
    name: "Pooja Reddy",
    skills: "Lead Generation, Cold Calling, Hubspot",
    YOE: 1,
    highestEducation: "Bachelors in Business",
    source: "Northstarz",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/pooja-reddy-9096",
  },
  {
    id: "9b1c2d3e-4f5a-4089-01a7-890123456789",
    name: "Sandeep Kumar",
    skills: "Chemical Engineering, Spectroscopy, Lab Work",
    YOE: 10,
    highestEducation: "PhD in Chemistry",
    source: "University Placement",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/sandeep-kumar-01a7",
  },
  {
    id: "a0c2d3e4-5f6b-4190-12b8-901234567890",
    name: "Varun Mehta",
    skills: "Market Research, Data Analysis, SQL",
    YOE: 6,
    highestEducation: "Bachelors in Economics",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/varun-mehta-12b8",
  },
  {
    id: "b1d3e4f5-6a7c-4201-23c9-012345678901",
    name: "Harshita Das",
    skills: "Sourcing, Boolean Search, Tech Recruitment",
    YOE: 4,
    highestEducation: "Masters in HR",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/harshita-das-23c9",
  },
  {
    id: "c2e4f5a6-7b8d-4312-34d0-123456789012",
    name: "Gautam Singh",
    skills: "Financial Reporting, GAAP, SAP FICO",
    YOE: 7,
    highestEducation: "CA/CPA",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/gautam-singh-34d0",
  },
  {
    id: "d3f5a6b7-8c9e-4423-45e1-234567890123",
    name: "Karan Johar",
    skills: "Cloud Infrastructure, Azure, Docker",
    YOE: 9,
    highestEducation: "Bachelors in IT",
    source: "Monster",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/karan-johar-45e1",
  },
  {
    id: "e4a6b7c8-9d0f-4534-56f2-345678901234",
    name: "Rina Shah",
    skills: "Product Marketing, Go-to-Market Strategy",
    YOE: 6,
    highestEducation: "MBA in Marketing",
    source: "Indeed",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/rina-shah-56f2",
  },
  {
    id: "f5b7c8d9-0e1a-4645-6703-456789012345",
    name: "Naveen Bhatia",
    skills: "C#, .NET, SQL Server",
    YOE: 12,
    highestEducation: "Masters in Engineering",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/naveen-bhatia-6703",
  },
  {
    id: "0c8d9e0f-1a2b-4756-7814-567890123456",
    name: "Saloni Goel",
    skills: "Internal Audit, SOX Compliance",
    YOE: 3,
    highestEducation: "Bachelors in Accounting",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/saloni-goel-7814",
  },
  {
    id: "1d9e0f1a-2b3c-4867-8925-678901234567",
    name: "Amitabh Mehra",
    skills: "HR Policies, Compensation & Benefits",
    YOE: 10,
    highestEducation: "Masters in HR",
    source: "LinkedIn",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/amitabh-mehra-8925",
  },
  {
    id: "2e0f1a2b-3c4d-4978-9036-789012345678",
    name: "Jessica D'souza",
    skills: "Foreign Exchange, Treasury Management",
    YOE: 5,
    highestEducation: "MBA in Finance",
    source: "Monster",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/jessica-dsouza-9036",
  },
  {
    id: "3f1a2b3c-4d5e-4a89-0147-890123456789",
    name: "Manish Rawat",
    skills: "System Security, Firewall Management",
    YOE: 7,
    highestEducation: "Bachelors in CS",
    source: "Indeed",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/manish-rawat-0147",
  },
  {
    id: "4a2b3c4d-5e6f-4b90-1258-901234567890",
    name: "Tina Verma",
    skills: "Public Relations, Media Outreach",
    YOE: 3,
    highestEducation: "Bachelors in Comm.",
    source: "Northstarz",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/tina-verma-1258",
  },
  {
    id: "5b3c4d5e-6f7a-4c01-2369-012345678901",
    name: "Zoya Khan",
    skills: "Mobile UI/UX, Adobe XD, User Testing",
    YOE: 6,
    highestEducation: "Masters in Design",
    source: "Dribbble",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/zoya-khan-2369",
  },
  {
    id: "6c4d5e6f-7a8b-4d12-3470-123456789012",
    name: "Abhinav Singh",
    skills: "Warehouse Management, Inventory Control",
    YOE: 11,
    highestEducation: "MBA in Operations",
    source: "Referral",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/abhinav-singh-3470",
  },
  {
    id: "7d5e6f7a-8b9c-4e23-4581-234567890123",
    name: "Murali Iyer",
    skills: "Technical Sales, Solution Architecture",
    YOE: 14,
    highestEducation: "Bachelors in Engineering",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/murali-iyer-4581",
  },
  {
    id: "8e6f7a8b-9c0d-4f34-5692-345678901234",
    name: "Simran Kaur",
    skills: "Digital Content Strategy, Video Production",
    YOE: 5,
    highestEducation: "Bachelors in Film",
    source: "Monster",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/simran-kaur-5692",
  },
  {
    id: "9f7a8b9c-0d1e-4045-67a3-456789012345",
    name: "Pawan Dubey",
    skills: "Environmental Engineering, Waste Management",
    YOE: 8,
    highestEducation: "Masters in Eng.",
    source: "Indeed",
    status: -1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/pawan-dubey-67a3",
  },
  {
    id: "a08b9c0d-1e2f-4156-78b4-567890123456",
    name: "Nikita Sharma",
    skills: "Machine Learning Engineering, Python, Keras",
    YOE: 4,
    highestEducation: "Masters in CS",
    source: "Northstarz",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/nikita-sharma-78b4",
  },
  {
    id: "b19c0d1e-2f3a-4267-89c5-678901234567",
    name: "Hitesh Goyal",
    skills: "Sales Operations, CRM Administration",
    YOE: 7,
    highestEducation: "MBA",
    source: "LinkedIn",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/hitesh-goyal-89c5",
  },
  {
    id: "c2a0d1e2-3f4b-4378-90d6-789012345678",
    name: "Meghna Reddy",
    skills: "Project Coordination, MS Project",
    YOE: 2,
    highestEducation: "Bachelors in Arts",
    source: "Referral",
    status: 1,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/meghna-reddy-90d6",
  },
  {
    id: "d3b1e2f3-4a5c-4489-01e7-890123456789",
    name: "Samir Varma",
    skills: "IT Auditing, Risk Management",
    YOE: 10,
    highestEducation: "CISA, Masters in IT",
    source: "Monster",
    status: 0,
    designation: "Software Engineer",
    linkedin: "https://www.linkedin.com/in/samir-varma-01e7",
  },
];

export const STATUS_TO_CANDIDATE_MAPPER = {
    "-3": {
        label: "Call back later",
        variant: "warning",
    },
    "-2": {
        label: "Not Interested",
        variant: "secondary",
    },
    "-1": {
        label: "Not Connected",
        variant: "secondary-dark",
    },
    "0": {
        label: "Outreached",
        variant: "secondary",
    },
    "1": {
        label: "Applied",
        variant: "info",
    },
    "2": {
        label: "Interviewed",
        variant: "primary",
    },
    "3": {
        label: "Shortlisted",
        variant: "success",
    },
    "4": {
        label: "Onhold",
        variant: "warning",
    },
    "5": {
        label: "Rejected",
        variant: "danger",
    }
}

export const CANDIDATE_STATUS = {
    "CALL_BACK_LATER": -3,
    "NOT_INTERESTED": -2,
    "NOT_CONNECTED": -1,
    "OUTREACHED": 0,
    "APPLIED": 1,
    "INTERVIEWED": 2,
    "SHORTLISTED": 3,
    "ONHOLD": 4,
    "REJECTED": 5
}
